import React from 'react';
import PropTypes from "prop-types";

const DeliveryChoice = ({ deliveryChosen, onDeliveryChoiceMade }) => {  
    return (
        <div>
            <fieldset>
                <legend>
                    Please choose either collection or delivery
                    </legend>
                <div className="control">
                    <label className="radio">
                        <input
                            type="radio"
                            name="Collection"
                            onChange={() => { onDeliveryChoiceMade(true); }}
                            checked={deliveryChosen} />
                        {' '}Delivery
                    </label>
                    <label className="radio">
                        <input
                            type="radio"
                            name="Collection"
                            onChange={() => { onDeliveryChoiceMade(false); }}
                            checked={!deliveryChosen}  />
                            {' '}Collection
                    </label>    
                </div>
            </fieldset>
        </div>
        );
};

DeliveryChoice.propTypes = {  
    onDeliveryChoiceMade: PropTypes.func.isRequired,
    deliveryChosen: PropTypes.bool.isRequired
}

export default DeliveryChoice;